import packageInfo from '../../../../../package.json'

export const environment = {
  appVersion: packageInfo.version,
  production: false,
  localEnv: false,
  enableDebug: true,
  serverName: 'Humecloud.dev',
  serverUrl: 'https://manager.dev.humecloud.com',
  deviceApiUrl: 'https://apps.dev.humecloud.com/htv',
  deviceWebSocketUrl: 'wss://apps.dev.humecloud.com/devices/ws',
  appUrl: 'https://apps.dev.humecloud.com/htv',
  appDomain: 'apps.dev.humecloud.com',
  htvApiUrl: 'https://api.dev.htv.humecloud.com',
  cmnLocationApiUrl: 'https://api.dev.common.humecloud.com',
  sentry: {
    environment: 'development',
    tracesSampleRate: 1.0,
  },
}
